/* 🤖 this file was generated by svg-to-ts */
export const matIconNearbyError: {
  name: 'nearby-error';
  data: string;
} = {
  name: 'nearby-error',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12 7.57 4.42 4.42L12 16.41l-4.42-4.42L12 7.57zm0 11.62-7.2-7.2 7.2-7.2 6 6V7.16l-4.58-4.58c-.78-.78-2.05-.78-2.83 0l-8.01 8c-.78.78-.78 2.05 0 2.83l8.01 8c.78.78 2.05.78 2.83 0L18 16.82v-3.63l-6 6zm8 .81h2v2h-2v-2zm2-10h-2v8h2v-8"/></svg>`
};
